import './seatrail/style';
import FormStructure from './seatrail/form_structure';

export default FormStructure;